import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import scrollIntoView from 'scroll-into-view';
import { document } from '../../../helpers/BrowserHelpers';
import Popover from '../../../components/Popover';
import computePopoverControl from '../../utils/computePopoverControl';
import getListElementPlacement from '../../utils/getListElementPlacement';
import UserPickerItem from './UserPickerItem';
import NotePickerItem from './NotePickerItem';
import PickerItem from './PickerItem';
var POPOVER_HEIGHT = 260;
var POPOVER_WIDTH = 320;

var Picker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Picker, _React$PureComponent);

  function Picker(props, context) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onPluginStateChange", function () {
      _this.computeControl();

      var pluginState = _this.props.pluginStore.getItem('state');

      _this.setState(pluginState);
    });

    _defineProperty(_assertThisInitialized(_this), "computeControl", function () {
      var popoverControl = computePopoverControl({
        containerEl: _this.props.editor.el,
        bottomSpace: _this.props.bottomSpace,
        popoverMaxHeight: POPOVER_HEIGHT,
        popoverMaxWidth: POPOVER_WIDTH
      });

      if (!popoverControl) {
        return;
      }

      _this.setState({
        popoverStyle: popoverControl.style
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (item, index, isSelected) {
      switch (item.type) {
        case 'users':
          return React.createElement(UserPickerItem, {
            user: item.data,
            index: index,
            isSelected: isSelected,
            onSelectItem: function onSelectItem(event) {
              return _this.onSelectItem(event, item, index);
            },
            onClickItem: function onClickItem(event) {
              return _this.onClickItem(event, item, index);
            }
          });

        case 'notes':
          return React.createElement(NotePickerItem, {
            note: item.data,
            index: index,
            isSelected: isSelected,
            onSelectItem: function onSelectItem(event) {
              return _this.onSelectItem(event, item, index);
            },
            onClickItem: function onClickItem(event) {
              return _this.onClickItem(event, item, index);
            }
          });

        default:
          return _this.renderCustomItem(item, index, isSelected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickItem", function (event, item, index) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onClick(item, index);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectItem", function (event, item, index) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onSelect(item, index);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      return event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "focusItem", function () {
      var index = _this.state.index;
      var el = document.querySelector('.mention-picker-item[data-mention-picker-item-index="'.concat(index, '"]'));

      if (!el) {
        console.warn('MentionPickerPlugin - Cant find item to focus in DOM');
        return;
      }

      var _getListElementPlacem = getListElementPlacement(el, _this.popoverRef.current),
          visible = _getListElementPlacem.visible,
          top = _getListElementPlacem.top;

      if (!visible) {
        scrollIntoView(el, {
          time: 0,
          align: {
            top: top ? 0 : 1,
            topOffset: top ? 10 : -10
          },
          validTarget: function validTarget(target) {
            return target.className && target.className.indexOf('mention-picker-scrollable') >= 0;
          }
        });
      }
    });

    _this.state = _objectSpread({
      popoverStyle: {}
    }, _this.props.pluginStore.getItem('state'));
    _this.popoverRef = React.createRef();
    return _this;
  }

  _createClass(Picker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isVisible) {
        this.computeControl();
      }

      this.props.pluginStore.subscribeToItem('state', this.onPluginStateChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Recompute popover position when it appears
      if (prevState.isVisible !== this.state.isVisible) {
        this.computeControl();
      } // After selection via keyboard, focus selected item


      if (prevState.index !== this.state.index && this.state.selectedViaKeyboard) {
        this.focusItem();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.pluginStore.unsubscribeFromItem('state', this.onPluginStateChange);
    }
  }, {
    key: "renderCustomItem",
    value: function renderCustomItem(item, index, isSelected) {
      var _this2 = this;

      return React.createElement(PickerItem, {
        key: item.data.id,
        item: item,
        index: index,
        isSelected: isSelected,
        onMouseMove: function onMouseMove(event) {
          _this2.onSelectItem(event, item, index);
        },
        onClick: function onClick(event) {
          _this2.onClickItem(event, item, index);
        },
        renderTitle: function renderTitle() {
          return item.renderTitle();
        },
        renderSubtitle: function renderSubtitle() {
          return item.renderSubtitle();
        },
        renderIcon: function renderIcon(_ref) {
          var width = _ref.width;
          return item.renderIcon({
            width: width
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          isVisible = _this$state.isVisible,
          popoverStyle = _this$state.popoverStyle,
          items = _this$state.items,
          index = _this$state.index;

      if (!isVisible) {
        return false;
      }

      return React.createElement(Popover, {
        className: "mention-picker-scrollable scroll-y",
        style: _objectSpread({}, popoverStyle, {
          width: POPOVER_WIDTH,
          maxHeight: POPOVER_HEIGHT
        }),
        ref: this.popoverRef,
        onMouseDown: this.onMouseDown
      }, React.createElement("div", {
        className: "height-full scroll-y",
        "data-toolbar": "mention-picker"
      }, items.map(function (item, currentIndex) {
        return _this3.renderItem(item, currentIndex, currentIndex === index);
      })));
    }
  }]);

  return Picker;
}(React.PureComponent);

_defineProperty(Picker, "propTypes", {
  pluginStore: PropTypes.shape({
    getItem: PropTypes.func.isRequired,
    subscribeToItem: PropTypes.func.isRequired,
    unsubscribeFromItem: PropTypes.func.isRequired
  }),
  editor: PropTypes.instanceOf(Editor).isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  bottomSpace: PropTypes.number.isRequired
});

export default Picker;